import React, { ReactElement } from "react";
import styles from "./MandatoryFieldText.module.css";

const MandatoryFieldText: React.FC<{}> = (): ReactElement => (
  <span className={styles.required_field}>* mandatory field</span>
);

export default MandatoryFieldText;
